import {styled} from '@mui/material'
import {FormErrorText} from 'components/Control/Form'
import {fieldsComponents, formFields} from 'constants/forms'
import {useFormContext} from 'react-hook-form'
import {setValueOptions} from 'services/utils/formUtils'
import {useI18n} from 'store/Store'

const CreateVolunteer = ({key, errorMessage}) => {
    const {i18n} = useI18n()
    const formContext = useFormContext()
    const {
        control: formControl,
        formState: {errors: formErrors},
        setValue,
    } = formContext

    const setAddressValue = (name) => (address) => {
        setValue(name, {...address}, setValueOptions)
    }

    return (
        <Container>
            {formFields.volunteers.map((field) => {
                const Component = fieldsComponents[field.fieldType]
                const key =
                    field.fieldType === 'multiple' ||
                    field.fieldType === 'address'
                        ? field.mainInputName
                        : field.key
                const options = field.options
                return (
                    <Component
                        key={field}
                        itemName="users"
                        name={key}
                        mainInputName={field.mainInputName}
                        label={i18n.t(`users.${field.key}`)}
                        control={formControl}
                        required={field.required}
                        errors={formErrors}
                        options={options}
                        subInputs={field.subInputs}
                        subInputsSizing={field.subInputsSizing}
                        setAddressValue={setAddressValue(key)}
                    />
                )
            })}

            {errorMessage && <FormErrorText>{errorMessage}</FormErrorText>}
        </Container>
    )
}

export default CreateVolunteer

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`
